"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react');




var _types = require('./types');
var _actions = require('shared/actions'); var _actions2 = _interopRequireDefault(_actions);
var _useBus = require('shared/hooks/useBus'); var _useBus2 = _interopRequireDefault(_useBus);














var _utils = require('./utils');

var _pins = require('shared/services/pins');
var _myMetadata = require('shared/services/myMetadata');











 const useInbox = ({
  myUserKey,
  selectedTeamKey,
  myInboxableTeamKeys,
  onError,
}) => {
  const [activeFilter, setActiveFilter] = _react.useState(_types.BlobjectFilter.ACTIVE)
  // The tab belongs to the inbox it was picked in: switching inbox shows All.
  const [tabChoice, setTabChoice] = _react.useState.call(void 0, { tab: _types.InboxTab.ALL, teamKey: selectedTeamKey })
  const activeTab = tabChoice.teamKey === selectedTeamKey ? tabChoice.tab : _types.InboxTab.ALL
  const setActiveTab = _react.useCallback.call(void 0, 
    (tab) => setTabChoice({ tab, teamKey: selectedTeamKey }),
    [selectedTeamKey],
  )
  const [nextPage, setNextPage] = _react.useState()

  const [blobjects, setBlobjects] = _react.useState.call(void 0, _utils.EMPTY_BLOBJECT_MAP)
  const [isLoading, setIsLoading] = _react.useState.call(void 0, false)
  const [hasDrained, setHasDrained] = _react.useState.call(void 0, false)
  // Bumped by every reset (a tab, filter or inbox change, or a refresh): a
  // page asked for before it is dropped, so a slower answer for the last tab
  // can't land in this one or overwrite its cursor.
  const generationRef = _react.useRef.call(void 0, 0)

  const blobjectKeysList = _react.useMemo.call(void 0, 
    () => Object.values(blobjects)
      .sort(_utils.makeCompareInboxRows.call(void 0, myUserKey))
      .map(_utils.keyExtractor),
    [blobjects, myUserKey],
  )

  const onLoad = _react.useCallback.call(void 0, 
    async ({ TeamKey, filter, tab, before, isSilent }) => {
      const generation = generationRef.current
      if (!isSilent) setIsLoading(true)
      // The first page (no cursor) also brings my pinned chats that belong
      // in the list.
      const isFirstPage = !before

      const response = await _actions2.default.getInbox({
        TeamKey,
        Completed: filter === _types.BlobjectFilter.COMPLETED,
        ...before,
        Limit: _utils.LOAD_LIMIT,
        ..._utils.tabRequestFields.call(void 0, tab),
        ...(isFirstPage && { WithPinned: true }),
      })
        .catch(() => {
          if (generation === generationRef.current) onError()
          return null
        })
      if (generation !== generationRef.current) return

      const Blobjects = _optionalChain([response, 'optionalAccess', _ => _.Blobjects]) || _utils.EMPTY_BLOBJECT_MAP
      const blobjectsList = Object.values(Blobjects)
      // A failed request keeps its cursor so a retry asks for the same page.
      // Backends that predate NextPage page by the oldest sort time alone,
      // which can skip chats that share it.
      const earliest = _utils.getEarliestBlobjectTime.call(void 0, blobjectsList, before && new Date(before.Before))
      const newNextPage = !response ? before : response.NextPage || (earliest && { Before: earliest.toISOString() })
      // Only the paged chats count towards a full page: pinned extras are not
      // a page of their own. (A backend that sends NextPage decides alone.)
      // Requests comes in one answer: the server lists every request chat.
      const pagedCount = blobjectsList.filter(b => !isFirstPage || !_pins.isPinnedByMe.call(void 0, b, myUserKey)).length
      const newHasDrained = tab === _types.InboxTab.REQUESTS || (!_optionalChain([response, 'optionalAccess', _2 => _2.NextPage]) && pagedCount < _utils.LOAD_LIMIT)

      if (isSilent) setBlobjects(Blobjects)
      else setBlobjects(ks => ({ ...ks, ...Blobjects }))

      setNextPage(newNextPage)
      setHasDrained(newHasDrained)
      setIsLoading(false)
    },
    [onError, myUserKey],
  )

  const onLoadMore = _react.useCallback.call(void 0, 
    () => onLoad({
      TeamKey: selectedTeamKey,
      filter: activeFilter,
      tab: activeTab,
      before: nextPage,
    }),
    [onLoad, activeFilter, activeTab, selectedTeamKey, nextPage],
  )

  // Chats unpinned off the list until scrolling reaches them.
  const unpinnedAwayRef = _react.useRef({})
  const handleUpdate = _react.useCallback.call(void 0, 
    (p) => {
      // SAFETY: the bus only calls this for updateActions (see useBus below),
      // whose payload carries the Blobjects map.
      const action = p 
      const [relevantBlobjectsMap, rejectedBlobjectsList] =
        _utils.filterRelevantBlobjects.call(void 0, {
          action,
          activeFilter,
          activeTab,
          selectedTeamKey,
          myInboxableTeamKeys,
          myUserKey,
        })
      // A chat unpinned here or elsewhere stays off the list while its place
      // is on a page not loaded yet, however many updates follow; a new pin,
      // new activity or paging brings it back.
      const away = new Set()
      Object.values(relevantBlobjectsMap).forEach(incoming => {
        const listed = blobjects[incoming.Key]
        const kept = unpinnedAwayRef.current[incoming.Key]
        const b = _myMetadata.withFresherMyMetadata.call(void 0, listed || kept, incoming, myUserKey)
        const wasPinnedHere = !!kept || (!!listed && _pins.isPinnedByMe.call(void 0, listed, myUserKey))
        if (wasPinnedHere && !_pins.isPinnedByMe.call(void 0, b, myUserKey) && !hasDrained && _utils.isPastCursor.call(void 0, b, nextPage)) {
          unpinnedAwayRef.current[incoming.Key] = b
          away.add(incoming.Key)
        } else {
          delete unpinnedAwayRef.current[incoming.Key]
        }
      })
      setBlobjects(ks => {
        const newMap = { ...ks }
        Object.values(relevantBlobjectsMap).forEach(incoming => {
          if (away.has(incoming.Key)) {
            delete newMap[incoming.Key]
            return
          }
          // Unread adds a chat when it turns unread, but keeps a listed one
          // you've since opened until the list reloads.
          if (activeTab === _types.InboxTab.UNREAD && !ks[incoming.Key] && !_utils.isUnreadForMe.call(void 0, incoming, myUserKey)) return
          // A chat carries nothing that says it has a pending scheduled
          // message or an open request, so Scheduled and Requests only
          // update the chats they list.
          if ((activeTab === _types.InboxTab.SCHEDULED || activeTab === _types.InboxTab.REQUESTS) && !ks[incoming.Key]) return
          // An update read before my latest pin or unpin keeps it, as the
          // store does.
          newMap[incoming.Key] = _myMetadata.withFresherMyMetadata.call(void 0, ks[incoming.Key], incoming, myUserKey)
        })
        rejectedBlobjectsList.forEach(b => delete newMap[b.Key])
        return newMap
      })
    },
    [selectedTeamKey, activeFilter, activeTab, myInboxableTeamKeys, myUserKey, blobjects, hasDrained, nextPage],
  )

  // The store drops a purged chat, so a row left for it would render blank.
  const handlePurge = _react.useCallback.call(void 0, 
    (p) => {
      // SAFETY: the bus only calls this for purgeActions (see useBus below).
      const { Blobjects: purgedKeys } = (p ).payload
      if (!_optionalChain([purgedKeys, 'optionalAccess', _3 => _3.length])) return
      setBlobjects(ks => {
        if (!purgedKeys.some(k => ks[k])) return ks
        const newMap = { ...ks }
        purgedKeys.forEach(k => delete newMap[k])
        return newMap
      })
    },
    [],
  )

  // Pinning moves a listed chat to the top (at once, or once the server
  // takes the pin near the limit: pinnedAtAfter); unpinning moves it back at
  // once; a failure puts it back. An unpinned chat whose place is on a page
  // not loaded yet leaves the list until scrolling reaches it (kept aside in
  // case the unpin fails).
  const handlePin = _react.useCallback.call(void 0, 
    (p) => {
      // SAFETY: the bus only calls this for pinActions, whose meta is PinAction's.
      const { type, meta } = p 
      const PinnedAt = _pins.pinnedAtAfter.call(void 0, _utils.pinPhase.call(void 0, type), meta)
      if (PinnedAt === undefined) return
      const listed = blobjects[meta.BKey] || unpinnedAwayRef.current[meta.BKey]
      if (!listed) return
      // A team chat I've never opened has no metadata of mine yet.
      const mine = listed.UserMetadata[myUserKey]
      const b = { ...listed, UserMetadata: { ...listed.UserMetadata, [myUserKey]: { ...mine, PinnedAt } } }
      const isAway = !PinnedAt && !hasDrained && _utils.isPastCursor.call(void 0, b, nextPage)
      delete unpinnedAwayRef.current[meta.BKey]
      if (isAway) unpinnedAwayRef.current[meta.BKey] = b
      setBlobjects(ks => {
        const newMap = { ...ks }
        if (isAway) delete newMap[meta.BKey]
        else newMap[meta.BKey] = b
        return newMap
      })
    },
    [blobjects, myUserKey, hasDrained, nextPage],
  )

  const onReset = _react.useCallback.call(void 0, 
    (isSilent) => {
      generationRef.current += 1
      unpinnedAwayRef.current = {}
      setHasDrained(false)
      if (!isSilent) setBlobjects(_utils.EMPTY_BLOBJECT_MAP)
      return onLoad({ TeamKey: selectedTeamKey, filter: activeFilter, tab: activeTab, isSilent })
    },
    [onLoad, selectedTeamKey, activeFilter, activeTab],
  )
  const onSilentReset = _react.useCallback.call(void 0, () => onReset(true), [onReset])

  _useBus2.default.call(void 0, _utils.resetActions, onSilentReset)
  _useBus2.default.call(void 0, _utils.updateActions, handleUpdate)
  _useBus2.default.call(void 0, _utils.purgeActions, handlePurge)
  _useBus2.default.call(void 0, _utils.pinActions, handlePin)
  _react.useLayoutEffect.call(void 0, () => { onReset() }, [onReset])

  return {
    activeFilter,
    setActiveFilter,
    activeTab,
    setActiveTab,
    isLoading,
    blobjectKeysList,
    onLoadMore,
    onReset,
    onSilentReset,
    hasDrained,
    setSelectedTeamKey: _actions2.default.setSelectedTeam,
  }
}; exports.useInbox = useInbox
